import { SprintStatus } from './sprint'
import {
  getWbsItemStatusColorCode,
  getWbsItemStatusDeepColorCode,
} from './wbsItem'
import { WbsItemStatus } from '../../domain/entity/WbsItemEntity'

// スプリントステータスの表示色は WBS アイテムのステータス色に合わせる。
// （sprint.ts は wbsItem.ts から参照されているため、ここに置いて循環参照を避ける）
export const getSprintStatusColor = (status: SprintStatus): string => {
  switch (status) {
    case SprintStatus.INPROGRESS:
      return getWbsItemStatusColorCode(WbsItemStatus.DOING)
    case SprintStatus.FINISHED:
      return getWbsItemStatusColorCode(WbsItemStatus.DONE)
    // getWbsItemStatusColorCode(TODO) は transparent で色がつかないため Deep を使う
    case SprintStatus.STANDBY:
      return getWbsItemStatusDeepColorCode(WbsItemStatus.TODO)
    case SprintStatus.CANCELED:
      return getWbsItemStatusColorCode(WbsItemStatus.DISCARD)
  }
}
